export const endlessPaginate = (options) => {
	const defaults = {
		// Twitter-style pagination container selector.
		containerSelector: ".endless_container",
		// Twitter-style pagination loading selector.
		loadingSelector: ".endless_loading",
		// Twitter-style pagination link selector.
		moreSelector: "a.endless_more",
		// Twitter-style pagination selector dataset which contains the actual URL
		moreSelectorDataUrl: "",
		// Digg-style pagination page template selector.
		pageSelector: ".endless_page_template",
		// Digg-style pagination link selector.
		pagesSelector: "a.endless_page_link",
		// Callback called when the user clicks to get another page.
		onClick: () => {},
		// Callback called when the new page is correctly displayed.
		onCompleted: () => {},
		// Set this to true to use the paginate-on-scroll feature.
		paginateOnScroll: false,
		// If paginate-on-scroll is on, this margin will be used.
		paginateOnScrollMargin: 1,
		// If paginate-on-scroll is on, it is possible to define chunks.
		paginateOnScrollChunkSize: 0,
	};
	const settings = { ...defaults, ...options };

	const getContext = (link) => {
		let url = "";
		if (link.hasAttribute("href")) {
			url = link.getAttribute("href");
		} else {
			url = link.getAttribute(settings.moreSelectorDataUrl);
		}
		return {
			key: link.getAttribute("rel").split(" ")[0],
			url: url,
		};
	};

	const init = () => {
		const body = document.querySelector("body");
		let loadedPages = 1;

		// Twitter-style pagination
		body.addEventListener("click", (e) => {
			const _this = e.target;
			if (_this.matches(settings.moreSelector)) {
				e.preventDefault();
				const link = _this;
				const container = link.closest(settings.containerSelector);
				const loading = container.querySelector(settings.loadingSelector);

				// Avoid multiple Ajax calls if loading is visible
				if (!(window.getComputedStyle(loading).display === "none")) {
					return false;
				}

				link.style.display = "none";
				loading.style.display = "block";
				const context = getContext(link);
				// Fire onClick callback
				if (settings.onClick.apply(link, [context]) !== false) {
					// Send the Ajax request
					const url = new URL(context.url, window.location.origin);
					url.searchParams.append("querystring_key", context.key);
					fetch(url, {
						headers: {
							"X-Requested-With": "XMLHttpRequest",
						},
						cache: "no-cache",
					})
						.then((response) => response.text())
						.then((fragment) => {
							container.outerHTML = fragment;
							// Increase the number of loaded pages.
							loadedPages += 1;
							// Fire onCompleted callback.
							settings.onCompleted.apply(link, [context, fragment.trim()]);
						})
						.catch((error) => {
							console.warn(error);
						});
				}
				return false;
			}
		});

		// On scroll pagination.
		if (settings.paginateOnScroll) {
			window.addEventListener("scroll", () => {
				const doc_height = document.body.clientHeight;
				const win_height = window.innerHeight;
				if (
					doc_height - win_height - window.scrollY <=
					settings.paginateOnScrollMargin
				) {
					// Do not paginate on scroll if chunks are used and
					// the current chunk is complete.
					const chunckSize = settings.paginateOnScrollChunkSize;
					if (!chunckSize || loadedPages % chunckSize) {
						const element = body.querySelector(settings.moreSelector);
						if (element) {
							element.click();
						}
					}
				}
			});
		}

		// Digg-style pagination
		body.addEventListener("click", (e) => {
			const _this = e.target;
			if (_this.matches(settings.pagesSelector)) {
				e.preventDefault();
				const link = _this;
				const context = getContext(link);

				// Fire onClick callback.
				if (settings.onClick.apply(link, [context]) !== false) {
					const page_template = link.closest(settings.pageSelector);
					// Send the Ajax request
					const url = new URL(context.url, window.location.origin);
					url.searchParams.append("querystring_key", context.key);
					fetch(url, {
						headers: {
							"X-Requested-With": "XMLHttpRequest",
						},
						cache: "no-cache",
					})
						.then((response) => response.text())
						.then((fragment) => {
							page_template.innerHTML = fragment;
							// Fire onCompleted callback.
							settings.onCompleted.apply(link, [context, fragment.trim()]);
						})
						.catch((error) => {
							console.warn(error);
						});
				}
				return false;
			}
		});
	};

	init();
};
